
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import ContactService from "../../../services/contactService";
import NotificationAlert from "react-notification-alert";
import ReactBSAlert from "react-bootstrap-sweetalert";
import FormInput from "../../../components/common/form/FormInput";
import _ from "lodash";
import { ContactPermissions } from "../../../services/permissions";
import formatFrontendDate from "../util/formatFrontendDate";

class ContactList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      alert: null,
      filterName: "",
      filterSurname: "",
      filterCompany: "",
      filteredList: [],
      currentPage: 1,
      itemsPerPage: 20,
    };
    this.delete = this.delete.bind(this);
    this.notify = this.notify.bind(this);
  }

  componentDidMount() {
    ContactService.list().then((response) => {
      this.setState({ list: response, filteredList: response });
    });
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
    console.log(this.state);
  };

  applyFilter = () => {
    const { list, filterName, filterSurname, filterCompany } = this.state;

    const filteredList = _.filter(list, (contact) => {
      const nameMatches = filterName
        ? _.includes(_.toLower(contact.firstName), _.toLower(filterName))
        : true;
      const surnameMatches = filterSurname
        ? _.includes(_.toLower(contact.lastName), _.toLower(filterSurname))
        : true;
      const companyMatches = filterCompany
        ? _.includes(
            _.toLower(contact.company.legalName),
            _.toLower(filterCompany)
          )
        : true;

      return nameMatches && surnameMatches && companyMatches;
    });

    this.setState({ filteredList: filteredList, currentPage: 1 });
  };

  clearFilter = () => {
    this.setState({
      filteredList: this.state.list,
      filterName: "",
      filterSurname: "",
      filterCompany: "",
      currentPage: 1,
    });
  };

  hideDeleteAlert = () => {
    this.setState({
      alert: null,
    });
  };

  confirmDeleteAlert = (uniqueId) => {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block" }}
          title="Are you sure?"
          onConfirm={() => this.delete(uniqueId)}
          onCancel={this.hideDeleteAlert}
          showCancel
          confirmBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnBsStyle="secondary"
          cancelBtnText="Cancel"
          btnSize=""
        >
          You won't be able to revert this!
        </ReactBSAlert>
      ),
    });
  };

  delete(uniqueId) {
    this.setState({ alert: null });
    ContactService.delete(uniqueId).then((response) => {
      console.log(response);
      this.notify(
        response.responseStatus.toLowerCase(),
        response.responseStatus,
        response.message
      );
      //TODO: TO be fixed with redux implementation
      //   this.props.history.push("/admin/dashboard");
      ContactService.list().then((response) => {
        console.log(response);
        this.setState({ list: response });
      });
    });
  }

  notify = (type, title, message) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    };
    this.refs.notificationAlert.notificationAlert(options);
  };

  paginate = (list) => {
    const { currentPage, itemsPerPage } = this.state;
    const startIndex = (currentPage - 1) * itemsPerPage;
    return list.slice(startIndex, startIndex + itemsPerPage);
  };

  handlePageChange = (pageNumber) => {
    this.setState({ currentPage: pageNumber });
  };

  renderPagination = () => {
    const { filteredList, currentPage, itemsPerPage } = this.state;
    const totalPages = Math.ceil(filteredList.length / itemsPerPage);
    if (totalPages <= 1) return null;

    const pageNumbers = [...Array(totalPages).keys()].map((i) => i + 1);

    return (
      <nav aria-label="Contact list pagination">
        <Pagination className="pagination justify-content-center mt-4">
          <PaginationItem disabled={currentPage === 1}>
            <PaginationLink
              href="#prev"
              onClick={(e) => {
                e.preventDefault();
                if (currentPage > 1) this.handlePageChange(currentPage - 1);
              }}
            >
              <i className="fa fa-angle-left" />
            </PaginationLink>
          </PaginationItem>
          {pageNumbers.map((num) => (
            <PaginationItem key={num} active={num === currentPage}>
              <PaginationLink
                href={`#page-${num}`}
                onClick={(e) => {
                  e.preventDefault();
                  this.handlePageChange(num);
                }}
              >
                {num}
              </PaginationLink>
            </PaginationItem>
          ))}
          <PaginationItem disabled={currentPage === totalPages}>
            <PaginationLink
              href="#next"
              onClick={(e) => {
                e.preventDefault();
                if (currentPage < totalPages)
                  this.handlePageChange(currentPage + 1);
              }}
            >
              <i className="fa fa-angle-right" />
            </PaginationLink>
          </PaginationItem>
        </Pagination>
      </nav>
    );
  };

  render() {
    let obj = this;
    const paginatedList = this.paginate(this.state.filteredList);

    return (
      <>
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <SimpleHeader
          name="List"
          parentName="Contact"
          heading="XareGrwoth"
          newBtnUrl="/crm/contact/create"
          newBtnText="Create Contact"
        />
        {this.state.alert}
        <Container className="mt--6" fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">Contacts List</h3>
                    </div>
                  </Row>
                  <Row>
                    <p style={{ fontStyle: "italic", color: "gray" }}>
                      Use the filters below to narrow down your search results.
                    </p>
                  </Row>
                  <Row>
                    {/*<Col sm={2}>
                        <FormInput
                            name="dateFrom"
                            className="form-control-label"
                            id="date"
                            placeholder="inputPlaceHolder.meetingReport.date"
                            type="date"
                            onChange={this.onChange}
                            value={this.state.dateFrom || ""}
                            label="Date From"
                        />
                      </Col>
                      <Col sm={2}>
                        <FormInput
                            name="dateTo"
                            className="form-control-label"
                            id="date"
                            placeholder="inputPlaceHolder.meetingReport.date"
                            type="date"
                            onChange={this.onChange}
                            value={this.state.dateTo || ""}
                            label="Date To"
                        />
                      </Col>*/}
                    <Col md="2">
                      <FormInput
                        name="filterName"
                        className="form-control-label"
                        id="name"
                        placeholder="Name"
                        type="text"
                        onChange={this.onChange}
                        label="Name"
                        value={this.state?.filterName || ""}
                        // errorMsg={this.props.errorObj?.name || ""}
                      />
                    </Col>
                    <Col md="2">
                      <FormInput
                        name="filterSurname"
                        className="form-control-label"
                        id="countryName"
                        placeholder="Surname"
                        type="text"
                        onChange={this.onChange}
                        label="Surname"
                        value={this.state?.filterSurname || ""}
                        // errorMsg={this.props.errorObj?.name || ""}
                      />
                    </Col>
                    <Col md="2">
                      <FormInput
                        name="filterCompany"
                        className="form-control-label"
                        id="companyName"
                        placeholder="Company Name"
                        type="text"
                        onChange={this.onChange}
                        label="Company Name"
                        value={this.state?.filterCompany || ""}
                        // errorMsg={this.props.errorObj?.name || ""}
                      />
                    </Col>
                    <Col md={"2"}></Col>
                    <Col sm={3} style={{ marginTop: "30px" }}>
                      <Button
                        size="md"
                        outline
                        color="default"
                        type="button"
                        onClick={this.applyFilter}
                      >
                        Apply Filter
                      </Button>
                      <Button
                        color="default"
                        size="md"
                        outline
                        type="button"
                        onClick={this.clearFilter}
                      >
                        Clear Filter
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th className="sort" data-sort="name" scope="col">
                        #
                      </th>
                      <th className="sort" data-sort="name" scope="col"></th>
                      <th className="sort" data-sort="budget" scope="col">
                        Date Created
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Title
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        First Name
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Last Name
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Company Name
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Contact Role
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Email Address
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Contact Number
                      </th>
                      <th scope="col" />
                    </tr>
                  </thead>
                  <tbody className="list">
                    {paginatedList.map(function (value, index) {
                      const globalIndex =
                        (obj.state.currentPage - 1) * obj.state.itemsPerPage +
                        index +
                        1;
                      return (
                        <tr
                          key={index}
                          style={{ display: ContactPermissions.read() }}
                        >
                          <td className="budget">{globalIndex}</td>
                          <td className="text-right">
                            <UncontrolledDropdown>
                              <DropdownToggle
                                color=""
                                size="sm"
                                className="btn-icon-only text-light"
                              >
                                <i className="fas fa-ellipsis-v" />
                              </DropdownToggle>
                              <DropdownMenu
                                className="dropdown-menu-arrow"
                                right
                                container="body"
                              >
                                <DropdownItem
                                  style={{ display: ContactPermissions.read() }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    obj.props.history.push(
                                      `/crm/contact/show/${value.uniqueId}`
                                    );
                                  }}
                                >
                                  Details
                                </DropdownItem>
                                <DropdownItem
                                  style={{
                                    display: ContactPermissions.update(
                                      value.createdBy
                                    ),
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    obj.props.history.push(
                                      `/crm/contact/edit/${value.uniqueId}`
                                    );
                                  }}
                                >
                                  Edit
                                </DropdownItem>
                                <DropdownItem
                                  style={{
                                    display: ContactPermissions.delete(),
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    obj.confirmDeleteAlert(`${value.uniqueId}`);
                                  }}
                                >
                                  Delete
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                          <td className="budget">
                            {formatFrontendDate(value.dateCreated)}
                          </td>
                          <td className="budget">{value.title}</td>
                          <td className="budget">{value.firstName}</td>
                          <td className="budget">{value.lastName}</td>
                          <td className="budget">{value.company.legalName}</td>
                          <td className="budget">{value.contactRole}</td>
                          <td className="budget">{value.email || "N/A"}</td>
                          <td className="budget">{value.number || "N/A"}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                {this.renderPagination()}
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default ContactList;
